var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParkingSharedbefore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "parkingShared_before_svg__Ebene_1",
    "data-name": "Ebene 1",
    preserveAspectRatio: "xMidYMid slice",
    viewBox: "0 0 1258 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .parkingShared_before_svg__cls-3,.parkingShared_before_svg__cls-6,.parkingShared_before_svg__cls-7,.parkingShared_before_svg__cls-9{fill:#fff}.parkingShared_before_svg__cls-3,.parkingShared_before_svg__cls-5,.parkingShared_before_svg__cls-8{stroke:#343a50;stroke-miterlimit:10}.parkingShared_before_svg__cls-3,.parkingShared_before_svg__cls-5{stroke-width:2px}.parkingShared_before_svg__cls-5{fill:#7e7e7e}.parkingShared_before_svg__cls-7{font-size:114.24px}.parkingShared_before_svg__cls-7,.parkingShared_before_svg__cls-9{font-family:Lato-Regular,Lato}.parkingShared_before_svg__cls-8{fill:#065494;stroke-width:3px}.parkingShared_before_svg__cls-9{font-size:41.66px}.parkingShared_before_svg__cls-10{letter-spacing:-.02em}.parkingShared_before_svg__cls-11,.parkingShared_before_svg__cls-12{letter-spacing:0}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parkingShared_before_svg__Privatparkplatz_teilen_Vorher",
    "data-name": "Privatparkplatz teilen_Vorher"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1261.03,
    height: 821.37,
    x: -1.51,
    y: 260.15,
    fill: "#4f4f4e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343a50",
    d: "M1258 261.66V1080H0V261.66h1258m3-3H-3V1083h1264V258.63z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parkingShared_before_svg__Weniger_Parkpl\\xE4tze_Vorher",
    "data-name": "Weniger Parkpl\\xE4tze_Vorher"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.66,
    height: 675.86,
    x: 857.75,
    y: 255.67,
    className: "parkingShared_before_svg__cls-3",
    transform: "rotate(-6.1 878.86 593.203)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "parkingShared_before_svg__Weniger_Parkpl\\xE4tze_Vorher-2",
    width: 675.86,
    height: 43.66,
    x: 40.62,
    y: 571.77,
    className: "parkingShared_before_svg__cls-3",
    "data-name": "Weniger Parkpl\\xE4tze_Vorher",
    transform: "rotate(-83.9 378.586 593.617)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 79.35,
    height: 67.7,
    x: 1,
    y: 0.98,
    fill: "#7e7e7e",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.01
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.7,
    x: 80.35,
    y: 0.98,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.7,
    x: 159.44,
    y: 0.98,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.7,
    x: 238.53,
    y: 0.98,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.7,
    x: 317.62,
    y: 0.98,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.7,
    x: 396.72,
    y: 0.98,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.7,
    x: 475.81,
    y: 0.98,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "633.99 68.68 554.9 68.68 554.9 .98 633.99 1 633.99 68.68",
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.68,
    x: 633.99,
    y: 1,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: -38.29,
    y: 68.68,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 40.8,
    y: 68.68,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 119.89,
    y: 68.68,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 198.99,
    y: 68.68,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 278.08,
    y: 68.68,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 357.17,
    y: 68.68,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 436.26,
    y: 68.68,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 515.35,
    y: 68.68,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 594.45,
    y: 68.68,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 1.26,
    y: 136.06,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 80.35,
    y: 136.06,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 159.44,
    y: 136.06,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 238.53,
    y: 136.06,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 317.62,
    y: 136.06,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 396.72,
    y: 136.06,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 475.81,
    y: 136.06,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 554.9,
    y: 136.06,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 633.99,
    y: 136.06,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: -38.29,
    y: 203.45,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 40.8,
    y: 203.45,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 119.89,
    y: 203.45,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 198.99,
    y: 203.45,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 278.08,
    y: 203.45,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 357.17,
    y: 203.45,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 436.26,
    y: 203.45,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 515.35,
    y: 203.45,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.09,
    height: 67.39,
    x: 594.45,
    y: 203.45,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 713,
    y: 1,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 791.82,
    y: 0.99,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 870.65,
    y: 0.99,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 949.48,
    y: 0.99,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1028.3,
    y: 0.99,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1107.13,
    y: 0.99,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1185.96,
    y: 0.99,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 673.59,
    y: 68.38,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 752.41,
    y: 68.38,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 831.24,
    y: 68.38,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 910.06,
    y: 68.38,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 988.89,
    y: 68.38,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1067.72,
    y: 68.38,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1146.54,
    y: 68.38,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1225.37,
    y: 68.38,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 713,
    y: 135.76,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 791.82,
    y: 135.76,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 870.65,
    y: 135.76,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 949.48,
    y: 135.76,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1028.3,
    y: 135.76,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1107.13,
    y: 135.76,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1185.96,
    y: 135.76,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 673.59,
    y: 203.15,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 752.41,
    y: 203.15,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 831.24,
    y: 203.15,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 910.06,
    y: 203.15,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 988.89,
    y: 203.15,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1067.72,
    y: 203.15,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1146.54,
    y: 203.15,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.83,
    height: 67.39,
    x: 1225.37,
    y: 203.15,
    className: "parkingShared_before_svg__cls-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parkingShared_before_svg___41",
    "data-name": 41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.62 406.27v-20.22H101.9v-6.63L136.2 332h11.24v46.15h10.77v7.89h-10.77v20.22zm0-28.11v-24.79q0-5.82.36-11.65h-.36c-2.36 4.34-4.26 7.54-6.39 11l-18.8 25.24v.23zM188.73 341.38h-.24l-13.37 7-2-7.66 16.8-8.68h8.87v74.26h-10.06z",
    className: "parkingShared_before_svg__cls-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "parkingShared_before_svg___43",
    "data-name": 43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1087 406.27v-20.22h-35.73v-6.63l34.3-47.42h11.24v46.15h10.76v7.89h-10.76v20.22zm0-28.11v-24.79q0-5.82.35-11.65h-.35c-2.37 4.34-4.26 7.54-6.39 11l-18.81 25.24v.23zM1118 394.73a35.69 35.69 0 0017 4.68c13.37 0 17.51-8.22 17.4-14.39-.12-10.4-9.82-14.85-19.88-14.85h-5.8v-7.54h5.8c7.57 0 17.15-3.77 17.15-12.57 0-5.94-3.9-11.2-13.48-11.2a28.86 28.86 0 00-15.38 4.92l-2.72-7.32c4-2.85 11.83-5.71 20.11-5.71 15.14 0 22 8.68 22 17.71 0 7.65-4.73 14.17-14.19 17.48v.23c9.46 1.83 17.15 8.68 17.15 19.08 0 11.88-9.58 22.27-28 22.27-8.63 0-16.2-2.62-20-5z",
    className: "parkingShared_before_svg__cls-6"
  })), /*#__PURE__*/React.createElement("text", {
    className: "parkingShared_before_svg__cls-7",
    transform: "matrix(1.04 0 0 1 564.41 408.21)"
  }, "\r\n   42\r\n  "), /*#__PURE__*/React.createElement("g", {
    id: "parkingShared_before_svg__Schilder"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153.58,
    height: 173.37,
    x: 88.15,
    y: 15.72,
    className: "parkingShared_before_svg__cls-8",
    rx: 29.62
  }), /*#__PURE__*/React.createElement("text", {
    className: "parkingShared_before_svg__cls-7",
    transform: "matrix(1.04 0 0 1 133.39 111.18)"
  }, "\r\n    P\r\n   "), /*#__PURE__*/React.createElement("text", {
    className: "parkingShared_before_svg__cls-9",
    transform: "matrix(1.04 0 0 1 113.9 169.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "parkingShared_before_svg__cls-10"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.5,
    y: 0,
    className: "parkingShared_before_svg__cls-11"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.29,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.04,
    y: 0,
    className: "parkingShared_before_svg__cls-12"
  }, "va"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.83,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("rect", {
    width: 153.58,
    height: 173.37,
    x: 547.83,
    y: 15.72,
    className: "parkingShared_before_svg__cls-8",
    rx: 29.62
  }), /*#__PURE__*/React.createElement("text", {
    className: "parkingShared_before_svg__cls-7",
    transform: "matrix(1.04 0 0 1 593.16 111.18)"
  }, "\r\n    P\r\n   "), /*#__PURE__*/React.createElement("text", {
    className: "parkingShared_before_svg__cls-9",
    transform: "matrix(1.04 0 0 1 573.56 169.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "parkingShared_before_svg__cls-10"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.5,
    y: 0,
    className: "parkingShared_before_svg__cls-11"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.29,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.04,
    y: 0,
    className: "parkingShared_before_svg__cls-12"
  }, "va"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.83,
    y: 0
  }, "t")), /*#__PURE__*/React.createElement("rect", {
    width: 153.58,
    height: 173.37,
    x: 1026.26,
    y: 15.72,
    className: "parkingShared_before_svg__cls-8",
    rx: 29.62
  }), /*#__PURE__*/React.createElement("text", {
    className: "parkingShared_before_svg__cls-7",
    transform: "matrix(1.04 0 0 1 1071.6 110.99)"
  }, "\r\n    P\r\n   "), /*#__PURE__*/React.createElement("text", {
    className: "parkingShared_before_svg__cls-9",
    transform: "matrix(1.04 0 0 1 1051.99 168.97)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "parkingShared_before_svg__cls-10"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.5,
    y: 0,
    className: "parkingShared_before_svg__cls-11"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.29,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.04,
    y: 0,
    className: "parkingShared_before_svg__cls-12"
  }, "va"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.83,
    y: 0
  }, "t"))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingSharedbefore);
export default __webpack_public_path__ + "static/media/parkingShared.before.2be2c837.svg";
export { ForwardRef as ReactComponent };